import React, { useState, useEffect } from "react";
import Paper_negative from "../images/Paper Negative.svg";
import Paper_plus from "../images/Paper Plus.svg";
import arrow from "../images/arrow.png";
import { email_templates, job_data, job_templates } from "./DummData";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import view from "../images/view.png";
import edit from "../images/edit.png";
import view_image from "../images/view.png";
import bin from "../images/delete.png";
import Copyright from "../components/Copyright"
import { DEFAULT_SALARY_TEMPLATE_IN, DEFAULT_SALARY_TEMPLATE_GB, TEPLATES_TAB_MAPPER, TEPMLATE_TABS } from "../constants/settingsConstants";
import axios from "axios";
import { server_API } from "../config";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Link } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa";
import { TailSpin } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import { CiMail } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import { selectCid } from "../features/companyid";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoMdArrowBack } from "react-icons/io";
import axiosInstance from "../axiosInstance";
import { getSpecialTab, getTemplateTab, getUserPrivilege, updateTemplateTab } from "../features/userid";
import SalaryTemplate from "./settings/salary/salaryTemplate";
import OfferTemplate from "./settings/offer/offerTemplate";
import Button from "./ui/Button";
import OfferModal from "./modal/Settings/OfferModal";
import SalaryModal from "./modal/Settings/SalaryModal";
import { roleTypes } from "../constants/common";

const Templates = () => {
  const cid = useSelector(selectCid);
  const [admin, setAdmin] = useState(false);
  const [loader, setLoader] = useState(false);
  const [editor, setEditor] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [viewer, setViewer] = useState(false);
  const dispatch = useDispatch();
  const [jobs, setJobs] = useState([]);
  const [allJobs, setAllJobs] = useState([]);
  const [tab, setTab] = useState(useSelector(getTemplateTab) || 1);
  const [openPopup, setOpenPopup] = useState(false);
  const [title, setTitle] = useState("");
  const [type, setType] = useState("Full-time");
  const [noOfPositions, setNoOfPositions] = useState("");
  const [department, setDepartment] = useState("");
  const [closingDate, setClosingDate] = useState("");
  const [openEmail, setOpenEmail] = useState(false);
  const [category, setCategory] = useState("");
  const [subject, setSubject] = useState("");
  const [fromEmail, setFromEmail] = useState("");
  const [toEmail, setToEmail] = useState("");
  const [attachment, setAttachment] = useState("");
  const [body, setBody] = useState("");
  const [lda, setLda] = useState("");
  const userPrivilege = useSelector(getUserPrivilege);
  const [experience, setExperience] = useState("");
  const [name, setName] = useState("");
  const [salaryFrom, setSalaryFrom] = useState("");
  const [salaryTo, setSalaryTo] = useState("");
  const [location, setLocation] = useState("");
  const [ws, setWs] = useState("");
  const [description, setDescription] = useState("");
  const [requirements, setRequirements] = useState("");
  const [skills, setSkills] = useState("");
  const [resCom, setResCom] = useState("");
  const [intScore, setIntScore] = useState("");
  const [vaScore, setVAScore] = useState("");
  const [uuid, setUuid] = useState("");
  const [emails, setEmails] = useState([]);
  const [appuid, setAppUid] = useState("");
  const [openPrompt, setOpenPrompt] = useState(false);
  const [prompt, setPrompt] = useState("");
  const [activeBody, setActiveBody] = useState("");
  const [activeSub, setActiveSub] = useState("");
  const [templatename, setTemplateName] = useState("");
  const [companyStatus, setCompanyStatus] = useState(true);
  const [companyData, setCompanyData] = useState(null);
  const [requiredVariables, setRequiredVariables] = useState([]);
  const [allVarsPresent, setAllVarsPresent] = useState(true);
  const [openOfferModal, setOpenOfferModal] = useState(false);
  const [openSalaryModal, setOpenSalaryModal] = useState(false);
  const navigate = useNavigate();


  const noOfferModule = userPrivilege === roleTypes.hiringManager;

  // useEffect(()=>{
  //   if(localStorage.getItem("index")){
  //     console.log(localStorage.getItem("index"))
  //     setTab(localStorage.getItem("index"))
  //   }

  // },[])

  const vars = [
    { name: "applicant.Name" },
    { jobName: "job.ProfileName" },
    { companyName: "company.Name" },
    { link: "applicant.UUID" },
  ];

  const JobCreate = (e) => {
    console.log(e);
    axiosInstance
      .post(`/v2/job/create`, {
        companyid: e.companyid,
        jobstatus: "Draft",
        profilename: e.profilename,
        positionnumber: e.positionnumber,
        workstyle: e.workstyle,
        postdate: e.postdate,
        closedate: e.closingDate,
        saveas: "draft",
        department: e.department,
        jdsummary: e.jdsummary,
        experience: e.experience,
        jobtype: e.jobtype,
        applicationlastdate: e.applicationlastdate,
        voiceanalysisscore: e.voiceanalysisscore,
        "location:": e["location:"],
        salaryfrom: e.salaryfrom,
        salaryto: e.salaryto,
        grade: e.grade,
        manual_trigger: e.manual_trigger,
        resume_threshold: e.resume_threshold,
        jobdescription: e.jobdescription,
        requirnmenet: e.requirements,
        skills: e.skills,
        resumecompatibility: e.resumecompatibility,
        assignrecruiter: e.assignrecruiter,
        assignhiringmanager: e.assignhiringmanager,
        firstreminder: e.firstreminder,
        finalreminder: e.finalreminder,
        selectedapplication: e.selectedapplication,
        interviewed: e.interviewed,
        aiscore: e.aiscore,
        totalapplication: 0,
        preferredlanguage: e.preferredlanguage,
        questionid: e.questionid,
        technicalweight: e.technicalweight,
        normaltext: e.normaltext,
        displaysalary: e.displaysalary,
      })
      .then((response) => {
        console.log(response);
        localStorage.setItem("jid", response.data.sucess);
        navigate("/jobs/new", { state: { saveas: "template" } });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const jobSubmit = (temp) => {
    // console.log(cid);

    console.log(temp);
    console.log(parseInt(noOfPositions));
    console.log(typeof lda);
    axiosInstance
      .post(`/v2/job/create`, {
        companyid: cid,
        jobstatus: "open",
        profilename: title,
        positionnumber: parseInt(noOfPositions),
        workstyle: ws,
        postdate: "2023-11-15T19:34:09.974Z",
        // "closedate": closingDate,
        saveas: "draft",
        experience: experience,
        jobtype: "",
        applicationlastdate: lda,
        voiceanalysisscore: parseInt(vaScore),
        "location:": location,
        salaryfrom: salaryFrom,
        salaryto: salaryTo,
        jobdescription: description,
        requirnmenet: requirements,
        skills: skills,
        resumecompatibility: resCom,
        assignrecruiter: "",
        assignhiringmanager: "",
        firstreminder: 12,
        finalreminder: 14,
        selectedapplication: 0,
        interviewed: 0,
        aiscore: parseInt(intScore),
        totalapplication: 0,
      })
      .then((response) => {
        console.log(response);
        navigate("/settings");
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (admin) {
      setWs("On-Site");
    } else if (editor) {
      setWs("Hybrid");
    } else if (viewer) {
      setWs("Remote");
    }
  }, [admin, editor, viewer]);

  useEffect(() => {
    axiosInstance
      .get(`/v2/company/get/${cid}`)
      .then((response) => {
        setCompanyData(response.data);
        setDepartments(response.data.departments);
        setAppUid(response.data.applicantemailtemplate1);
        if (response.data.companystatus !== undefined) {
          setCompanyStatus(response.data.companystatus);
        } else {
          setCompanyStatus(true);
        }
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [cid]);

  const deleteMail = (uuid, stat) => {
    axiosInstance
      .delete(`/v2/email/delete/${uuid}`)
      .then((response) => {
        console.log(response);
        if (stat == true) {
          axiosInstance
            .patch(`/v2/company/update`, {
              uuid: cid,
              applicantemailtemplate1: "",
            })
            .then((res) => {
              console.log(res);
              window.location.reload();
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    axiosInstance
      .get(`/v2/email/getcompanys/${cid}`)
      .then((response) => {
        console.log(response);
        setEmails(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const deleteJob = (id) => {
    axiosInstance
      .delete(`/v2/job/delete/${id}/${cid}`)
      .then((response) => {
        console.log(response);
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const editEmail = (uuid) => {
    setUuid(uuid);
    axiosInstance
      .get(`/v2/email/get/${uuid}/${cid}`)
      .then((response) => {
        console.log(response);
        setTemplateName(response.data.templatename);
        setBody(response.data.emailbody);
        setSubject(response.data.subject);
        setCategory(response.data.category);
        setTab(2);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (body) {
      const matches = body.match(/{{\.\w+}}/g); // Match {{.Something}}
      const uniqueVars = Array.from(new Set(matches || []));
      setRequiredVariables(uniqueVars);
    }
  }, [templatename]);

  useEffect(() => {
    setAllVarsPresent(requiredVariables.every((v) => body.includes(v)));
  }, [body]);

  const templateNameMap = {
    Creation: "Video Interview Notification",
    First_Reminder: "Video Interview Reminder 1",
    Final_Reminder: "Video Interview Reminder 2",
    BulkEmail: "Bulk Job Invitation",
    User_Creation: "New user creation",
    Rejected: "Rejected Application",
    Shortlist: "Shortlisted Application",
    User_Reminder: "New user creation - Reminder",
    User_Recall: "New user creation - Recall",
  };

  const patchMail = () => {
    axiosInstance
      .patch(`/v2/email/update`, {
        uuid: uuid,
        emailbody: activeBody,
        subject: activeSub,
      })
      .then((response) => {
        console.log(response);
        setOpenEmail(false);
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    axiosInstance
      .get(`/v2/job/getjobs/${cid}`)
      .then((res) => {
        console.log(res);
        const filtered_array = res.data.filter((f) => {
          if (f.saveas == "template") {
            return f;
          }
        });
        console.log(filtered_array);
        setJobs(filtered_array);
        setAllJobs(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (jobs.length > 0) {
      console.log(jobs);
    }
  }, [jobs]);

  useEffect(() => {
    dispatch(updateTemplateTab(tab));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab])

  const bodyClean = (text) => {
    text = text.replaceAll("&lt;&lt;name&gt;&gt;", "<<name>>");
    text = text.replaceAll("&lt;&lt;job&gt;&gt;", "<<job>>");
    text = text.replaceAll("&lt;&lt;company&gt;&gt;", "<<company>>");
    text = text.replaceAll(
      "&lt;&lt;link&gt;&gt;",
      "https://interviewguru.co/#/data?id=<<link>>"
    );

    return text;
  };

  const saveEmail = () => {
    axiosInstance
      .patch(`/v2/email/update`, {
        uuid: uuid,
        emailbody: body,
        companyid: cid,
        subject: subject,
      })
      .then((response) => {
        console.log(response);
        toast.success("Email Updated Successfully");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setDef = (cat, uuid) => {
    axiosInstance
      .patch(`/v2/company/update`, {
        uuid: cid,
        applicantemailtemplate1: uuid,
      })
      .then((res) => {
        console.log(res);
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const genJd = () => {
    console.log(prompt);
    setLoader(true);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      text: `${prompt} and format it using html tags`,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch("https://interviewguru.co/django/jd_gen", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setDescription(result.text);
        setLoader(false);
      })
      .catch((error) => {
        console.log("error", error);
        setLoader(false);
      });
  };

  return (
    <div>
      <div className="bg-[#f0f4fc] min-h-screen">
        {openPopup && (
          <div className="bg-white w-1/2  shadow-2xl border rounded-xl p-4 z-20 fixed left-1/2 top-1/2 -translate-y-1/2  -translate-x-1/2">
            <button
              className="text-right "
              onClick={() => {
                setOpenPopup(false);
              }}
            >
              X
            </button>
            <div className="text-center">
              <p className="">
                Assign a weight score to each of the below parameter as required
                for the job role. The Skills weightage will help you to identify
                your top candidates based on the job requirement.
              </p>
              <p>
                Ensure the sum total of all weighted scores will be 100. E.g.
                For a Customer Success role, the weights could look like:
              </p>
              <p>Resume Compatibility: 25</p>
              <p>Video Interview Score: 60</p>
              <p>Voice Analysis Score: 15</p>
              <p>Total Score: 100</p>
            </div>
          </div>
        )}
        {openEmail && (
          <div className="bg-white w-1/2  shadow-2xl border rounded-xl p-4 z-20 fixed left-1/2 top-1/2 -translate-y-1/2  -translate-x-1/2">
            <button
              className="text-right "
              onClick={() => {
                setOpenEmail(false);
              }}
            >
              X
            </button>
            <div className="">
              <p className="my-2 font-semibold">Subject</p>
              <input
                className="w-full p-3 rounded-xl mb-4 outline-none border"
                value={activeSub}
                onChange={(e) => {
                  setActiveSub(e.target.value);
                }}
              ></input>
              <p className="my-2 font-semibold">Body</p>
              <textarea
                rows="4"
                className="w-full p-3 rounded-xl mb-4 outline-none border"
                value={activeBody}
                onChange={(e) => {
                  setActiveBody(e.target.value);
                }}
              ></textarea>
              <div className="text-right">
                <button
                  className="bg-cyan-600 rounded-xl px-6 py-2 text-white"
                  onClick={() => {
                    patchMail();
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}
        {openPrompt && (
          <div className="bg-white w-1/2  shadow-2xl border rounded-xl p-4 z-20 fixed left-1/2 top-1/2 -translate-y-1/2  -translate-x-1/2">
            <button
              className="text-right "
              onClick={() => {
                setOpenPrompt(false);
              }}
            >
              X
            </button>
            <div>
              <p className="font-semibold text-xl my-2">
                Job description using AI
              </p>
              <p className="font-semibold my-1 mt-5">Prompt</p>
              <textarea
                rows="4"
                value={prompt}
                onChange={(e) => {
                  setPrompt(e.target.value);
                }}
                className="p-2 rounded-xl outline-none border w-full"
                placeholder="Share in a few sentences what your are hiring for"
              ></textarea>
              <div className="text-right">
                <button
                  onClick={() => {
                    genJd();
                  }}
                  className="bg-[#148EFF] px-5 py-2 rounded-lg text-white mt-3"
                >
                  {loader ? (
                    <TailSpin color="white" height="30" width="30"></TailSpin>
                  ) : (
                    "Generate"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

        {!companyStatus && (
          <div className="">
            <div className="fixed bg-white border shadow-xl md:w-1/2  p-4 z-40 rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="p-3 rounded-xl text-center  flex flex-col space-y-4">
                <div className="flex  items-center justify-between">
                  <p className="text-xl font-medium">Warning</p>
                  <button
                    onClick={() => {
                      navigate("/home");
                    }}
                    className="text-right"
                  >
                    X
                  </button>
                </div>
                <div className="h-[0.08rem] w-full  bg-gray-300"></div>
                <div>
                  <p className="my-6 font-semibold">
                    Your plan has expired and account has been suspended. Please
                    activate the account by renewing with a suitable plan for
                    continued access to the system.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
        {
          openOfferModal && <OfferModal onClose={() => { setOpenOfferModal(false) }} />
        }
        {
          openSalaryModal && <SalaryModal onClose={() => { setOpenSalaryModal(false) }} data={companyData?.company_countries?.[0] === "GB" ? DEFAULT_SALARY_TEMPLATE_GB : DEFAULT_SALARY_TEMPLATE_IN} companyCountryCode={companyData?.company_countries?.[0]} />
        }
        <div
          className={
            !companyStatus
              ? "bg-[#f0f4fc] blur  min-h-screen pointer-events-none "
              : "pt-5 px-10"
          }
        >
          <div className="flex items-center gap-2">
            {tab == 2 && (
              <div className="flex flex-row gap-1 items-center">
                <IoMdArrowBack
                  className="text-xl my-3  tooltip"
                  onClick={() => {
                    setTab(0);
                  }}
                >
                  back
                </IoMdArrowBack>
              </div>
            )}
            <p className="text-2xl font-semibold">Templates</p>
            {/* {
                     tab == 0 &&   
                    <button className="bg-[#148EFF] text-white px-4 rounded-lg py-2" onClick={()=>{setTab(2)}}>+ Add Email Template</button>
                    }
                    {
                        tab == 1 &&
                    <button className="bg-[#148EFF] text-white px-4 rounded-lg py-2" onClick={()=>{setTab(3)}}>+ Add Job Template</button>
                    } */}
          </div>
          <div className={`mt-6 ${tab === TEPLATES_TAB_MAPPER.SALARY || tab === TEPLATES_TAB_MAPPER.OFFER ? "bg-[#f0f4fc] rounded-xl overflow-hidden" : "bg-white"} rounded-xl `}>
            <div className="flex items-center justify-between bg-[#f0f4fc] pb-3 rounded-t-xl">
              <div className={`flex gap-2 bg-white p-1 rounded-md border `}>
                {TEPMLATE_TABS.filter((curr) => noOfferModule ? (curr.value === TEPLATES_TAB_MAPPER.SALARY ? false : curr.value !== TEPLATES_TAB_MAPPER.OFFER) : true).map((curr) => {
                  const isActive = tab === curr.value;
                  return (
                    <button
                      key={curr.value}
                      onClick={() => setTab(curr.value)}
                      disabled={curr.disabled}
                      className={`px-4 py-3 rounded-md text-base font-medium transition disabled:opacity-75 disabled:cursor-not-allowed ${isActive
                        ? "bg-web-blue text-white"
                        : "text-black hover:bg-gray-200"
                        }`}
                    >
                      {curr.label}
                    </button>
                  );
                })}
              </div>
              {
                (tab === TEPLATES_TAB_MAPPER.SALARY || tab === TEPLATES_TAB_MAPPER.OFFER) && <Button variant="black" onClick={() => {
                  if (tab === TEPLATES_TAB_MAPPER.OFFER) {
                    setOpenOfferModal(true)
                  } else if (tab === TEPLATES_TAB_MAPPER.SALARY) {
                    setOpenSalaryModal(true)
                  }
                }}>Create New +</Button>
              }
            </div>

            {
              tab === TEPLATES_TAB_MAPPER.SALARY && <SalaryTemplate companyData={companyData} />
            }

            {
              tab === TEPLATES_TAB_MAPPER.OFFER && <OfferTemplate openModal={openOfferModal} />
            }

            {tab == 0 && (
              <div className="p-5">
                <div className="mt-10">
                  <Table className="border-y text-sm ">
                    <Thead className="text-left text- top-0 z-30 bg-white">
                      <Tr>
                        <Th className="border-y p-2 py-4">No</Th>
                        <Th className="border-y p-2 ">Template Name</Th>
                        <Th className="border-y p-2">Subject</Th>
                        <Th className="border-y p-2">Category</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {emails.map((e, i) => {
                        return (
                          <Tr>
                            <Td
                              className={
                                appuid == e.uuid
                                  ? "border-y p-2"
                                  : "border-y p-2"
                              }
                            >
                              {i + 1}
                            </Td>
                            <Td
                              onClick={() => {
                                if (userPrivilege !== "Hiring Manager") {
                                  editEmail(e.uuid);
                                }
                              }}
                              className={`border-y p-2 ${userPrivilege === "Hiring Manager"
                                ? "text-gray-400 cursor-not-allowed"
                                : "text-blue-500 cursor-pointer"
                                }`}
                            >
                              {templateNameMap[e.templatename] ||
                                e.templatename}
                            </Td>
                            <Td className="border-y p-2">{e.subject}</Td>
                            <Td className="border-y p-2">{e.category}</Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </div>
              </div>
            )}

            {tab == 1 && (
              <div>
                <div className="p-5  rounded-xl ">
                  <div className="mt-10">
                    <Table className="border-y">
                      <Thead className="text-left text-sm top-0 z-30 bg-white">
                        <Tr>
                          <Th className="border-y p-2">No</Th>
                          <Th className="border-y p-2 ">Job Title</Th>
                          <Th className="border-y p-2">Department</Th>
                          <Th className="border-y p-2">Actions</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {jobs.map((e, i) => {
                          return (
                            <Tr className="text-sm ">
                              <Td className="border-y p-2">{i + 1}</Td>
                              <Td className="border-y p-2">{e.profilename}</Td>
                              <Td className="border-y p-2">{e.department}</Td>
                              <Td className="border-y  ">
                                <div className="flex justify-start gap-5">
                                  {/* Use Template button */}
                                  <button
                                    className={`py-1 px-1 ${userPrivilege === "Hiring Manager"
                                      ? "text-gray-400 cursor-not-allowed"
                                      : "text-blue-500"
                                      }`}
                                    onClick={() => {
                                      if (userPrivilege !== "Hiring Manager") {
                                        JobCreate(e);
                                      }
                                    }}
                                    disabled={
                                      userPrivilege === "Hiring Manager"
                                    }
                                  >
                                    Use template
                                  </button>

                                  {/* Delete button with icon */}
                                  <button
                                    onClick={() => {
                                      if (userPrivilege !== "Hiring Manager") {
                                        deleteJob(e.uuid);
                                      }
                                    }}
                                    disabled={
                                      userPrivilege === "Hiring Manager"
                                    }
                                    className={`${userPrivilege === "Hiring Manager"
                                      ? "cursor-not-allowed opacity-50"
                                      : ""
                                      }`}
                                  >
                                    <img
                                      src={bin}
                                      className="h-6 my-2"
                                      alt="Delete"
                                    />
                                  </button>
                                </div>
                              </Td>
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  </div>
                </div>
              </div>
            )}

            {tab == 2 && (
              <div>
                <ToastContainer></ToastContainer>
                <div className="p-5  rounded-xl ">
                  <div className="flex flex-col space-y-4">
                    <div className="flex w-full space-x-3">
                      <div className="w-1/2">
                        <div>
                          <p className="font-semibold">
                            Template Name{" "}
                            <span className="text-red-500">*</span>
                          </p>
                          <div className="w-full outline-none border px-2 py-1 rounded-lg mt-2 text-gray-500">
                            {templateNameMap[templatename] || templatename}
                          </div>
                        </div>
                      </div>
                      <div className="w-1/2">
                        <div>
                          <p className="font-semibold">
                            Category <span className="text-red-500">*</span>
                          </p>
                          <div className="w-full outline-none border px-2 py-1 rounded-lg mt-2 text-gray-500">
                            {category}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p className="font-semibold">
                        Subject <span className="text-red-500">*</span>
                      </p>
                      <input
                        value={subject}
                        onChange={(e) => {
                          setSubject(e.target.value);
                        }}
                        className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                      ></input>
                    </div>

                    <div>
                      <p className="font-semibold">
                        Email Body <span className="text-red-500">*</span>
                      </p>
                      <ReactQuill
                        value={body}
                        onChange={setBody}
                        rows="3"
                        theme="snow"
                        className=" w-full rounded-xl py-2 px-2 mt-2"
                      ></ReactQuill>
                    </div>
                  </div>
                  <p className="">
                    Please Note: Email Body should contain{" "}
                    {requiredVariables.map((v, i) => (
                      <span
                        key={i}
                        className="bg-red-100 text-red-500 p-0.5 py-1 rounded-xl mx-1"
                      >
                        {v}
                      </span>
                    ))}
                  </p>
                </div>
                <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>
                <div className="flex space-x-6  px-4 py-5 items-center justify-end w-full">
                  <button
                    disabled={!allVarsPresent}
                    className={
                      allVarsPresent
                        ? "px-6 py-2 text-white bg-[#09BF89] rounded-xl"
                        : "px-6 py-2 text-white bg-gray-300 rounded-xl"
                    }
                    onClick={() => {
                      saveEmail();
                    }}
                  >
                    Update email template
                  </button>
                </div>
              </div>
            )}
            {tab == 3 && (
              <div>
                <div className="p-5  rounded-xl ">
                  <div className="flex flex-col space-y-4">
                    <div className="flex w-full space-x-3">
                      <div className="w-1/2">
                        <p className="font-semibold">
                          Job Title <span className="text-red-500">*</span>
                        </p>
                        <input
                          onChange={(e) => {
                            setTitle(e.target.value);
                          }}
                          value={title}
                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                        ></input>
                      </div>
                      <div className="w-1/2">
                        <p className="font-semibold">Department</p>
                        <select
                          value={department}
                          onChange={(e) => {
                            setDepartment(e.target.value);
                          }}
                          className="border  px-1 py-1 rounded-lg mt-1 w-full"
                        >
                          {departments.map((s) => {
                            return <option value={s}>{s}</option>;
                          })}
                        </select>
                      </div>
                    </div>

                    <div className="flex flex-col space-y-4">
                      <div>
                        <div className=" rounded-xl ">
                          <div className="flex flex-col space-y-4">
                            <div>
                              <div className="flex items-center space-x-6">
                                <p className="font-semibold">
                                  Job Description{" "}
                                  <span className="text-red-500">*</span>
                                </p>
                                {loader ? (
                                  <TailSpin
                                    color="black"
                                    height="30"
                                    width="30"
                                  ></TailSpin>
                                ) : (
                                  <button
                                    onClick={() => {
                                      setOpenPrompt(true);
                                    }}
                                    className="font-semibold   bg-gradient-to-r   from-[#F7284AA3] via-[#7366FFCC] to-[#0DCD94CC]   rounded-xl  p-[0.15rem]"
                                  >
                                    <div className="h-full p-2 rounded-lg w-full bg-white">
                                      <p className="bg-gradient-to-r brightness-110 text-transparent bg-clip-text from-[#F7284AA3] via-[#7366FFCC] to-[#0DCD94CC]">
                                        Generate using AI
                                      </p>
                                    </div>
                                  </button>
                                )}
                              </div>
                              <ReactQuill
                                value={description}
                                onChange={setDescription}
                                rows="3"
                                theme="snow"
                                className=" w-full rounded-xl py-2 px-2 mt-2"
                              ></ReactQuill>
                            </div>

                            <div className="flex items-center space-x-2">
                              <p className="font-semibold">
                                Assign Skills Weightage{" "}
                              </p>
                              <button
                                onClick={() => {
                                  setOpenPopup(true);
                                }}
                              >
                                <FaInfoCircle></FaInfoCircle>
                              </button>
                            </div>
                            <div className="">
                              <div className="w-full flex space-x-3 mt-3">
                                <div className="w-1/4">
                                  <p className="font-semibold tooltip">
                                    Resume Compatibility{" "}
                                    <span className="tooltiptext p-2 px-3 font-normal">
                                      Res Explaination
                                    </span>
                                  </p>
                                  <input
                                    value={resCom}
                                    onChange={(e) => {
                                      setResCom(e.target.value);
                                    }}
                                    className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                  ></input>
                                </div>
                                <div className="w-1/4">
                                  <p className="font-semibold tooltip">
                                    AI Interview Score{" "}
                                    <span className="tooltiptext p-2 px-3 font-normal">
                                      Res Explaination
                                    </span>
                                  </p>
                                  <input
                                    value={intScore}
                                    onChange={(e) => {
                                      setIntScore(e.target.value);
                                    }}
                                    className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                  ></input>
                                </div>
                                <div className="w-1/4">
                                  <p className="font-semibold tooltip">
                                    Voice Analysis Score{" "}
                                    <span className="tooltiptext p-2 px-3 font-normal">
                                      Res Explaination
                                    </span>
                                  </p>
                                  <input
                                    value={vaScore}
                                    onChange={(e) => {
                                      setVAScore(e.target.value);
                                    }}
                                    className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                  ></input>
                                </div>
                                <div className="w-1/4">
                                  <p className="font-semibold">Total Score </p>
                                  <input
                                    value={
                                      resCom &&
                                      intScore &&
                                      vaScore &&
                                      parseInt(resCom) +
                                      parseInt(intScore) +
                                      parseInt(vaScore)
                                    }
                                    className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                                  ></input>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-[#E9EBFA] h-[0.1rem] w-full mt-5"></div>
                <div className="flex space-x-6  px-4 py-5 items-center justify-end w-full">
                  <button className="px-10 py-2 bg-white border border-[#F7284A] text-[#F7284A] rounded-xl">
                    Cancel
                  </button>
                  <button
                    className="px-6 py-2 text-white bg-[#09BF89] rounded-xl"
                    onClick={() => {
                      jobSubmit();
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <Copyright />
      </div>
    </div>
  );
};

export default Templates;
